import { useAuthStore } from "@/lib/auth-store";
import type { PublishingStatus } from "@/types/api";

/**
 * Retourneert de globale publishing_status. Default 'testing' als
 * de huidige gebruiker nog niet geladen is (veilig).
 */
export function usePublishingStatus(): PublishingStatus {
  return useAuthStore((s) => s.gebruiker?.publishing_status ?? "testing");
}

export function useIsLive(): boolean {
  return usePublishingStatus() === "live";
}
